import Vue from 'vue';
export default {
  data() {
    return {
      dashboardData: [],
      alarm: require('@/assets/images/alarm.svg'),
      currentMissionSearchText: '',
      //detail modal
      followUpDashboardDetailModal: false,
      missionId: null,
      missionPhoneId: null,
      phoneCode: '',
      phoneId: null,
      searchTxt: '',
      timer: null,
      sendModalType: '',
      selectedRow: -1,
    };
  },
  computed: {
    filteredDashboardData: function () {
      return [...this.currentFollowUpCodesList].filter(({ code }) => code.includes(this.searchTxt));
    },
  },
  methods: {
    resetSelectedRow() {
      this.selectedRow = -1;
    },
    onContextClick(e, data) {
      console.log(e);
      // this.rightClickHandler(e, data);
      this.selectedRow = data?.item?.id;
    },
    refreshList: function () {
      this.getMissionPhoneFollowUpDashboardFunction(true);
    },
    readyFollowUpDashboard: function (temp) {
      for (let i = 0; i < this.dashboardData.length; i++) {
        clearInterval(this.dashboardData[i].seenDurationInterval);
        clearInterval(this.dashboardData[i].moveFromStationDurationInterval);
        clearInterval(this.dashboardData[i].arriveToLocationDurationInterval);
        clearInterval(this.dashboardData[i].patientVisitDurationInterval);
        clearInterval(this.dashboardData[i].arriveToHospitalDurationInterval);
        clearInterval(this.dashboardData[i].hospitalWaitingDurationInterval);
        this.dashboardData[i].seenDurationInterval = null;
        this.dashboardData[i].moveFromStationDurationInterval = null;
        this.dashboardData[i].arriveToLocationDurationInterval = null;
        this.dashboardData[i].patientVisitDurationInterval = null;
        this.dashboardData[i].arriveToHospitalDurationInterval = null;
        this.dashboardData[i].hospitalWaitingDurationInterval = null;
      }
      this.dashboardData = [];
      let moment = require('moment');
      if (temp.length > 0) {
        for (let i = 0; i < temp.length; i++) {
          let state = '-';
          let stateTooltip = '';
          let cardClass = '';
          let sectionClass = '';
          let stateClass = '';
          if (temp[i].phoneCurrentState) {
            if (temp[i].phoneCurrentState.length > 20) {
              state = temp[i].phoneCurrentState.substring(0, 19);
              stateTooltip = temp[i].phoneCurrentState;
            } else {
              state = temp[i].phoneCurrentState;
              stateTooltip = '';
            }
          }
          if (temp[i].missionRank != null) {
            if (temp[i].missionRank == 1) {
              cardClass = 'main-card-followup-dashbord2';
              sectionClass = 'mobileHeader1 animate__animated animate__rotateInDownRight';
              stateClass = 'ml-1 mission-state-text2';
            } else if (temp[i].missionRank == 2) {
              cardClass = 'main-card-followup-dashbord3';
              sectionClass = 'mobileHeader2 animate__animated animate__rotateInDownRight';
              stateClass = 'ml-1 mission-state-text3';
            } else if (temp[i].missionRank == 3) {
              //red
              cardClass = 'main-card-followup-dashbord';
              sectionClass = 'mobileHeader animate__animated animate__rotateInDownRight';
              stateClass = 'ml-1 mission-state-text';
            } else if (temp[i].missionRank == 0) {
              //white
              cardClass = 'main-card-followup-dashbord4';
              sectionClass = 'mobileHeader4 animate__animated animate__rotateInDownRight';
              stateClass = 'ml-1 mission-state-text4';
            }
          }
          this.dashboardData.push({
            cardClass: cardClass,
            code: temp[i].phoneCode ? temp[i].phoneCode : '-',
            id: temp[i].id,
            missionDuration: null,
            missionDurationInterval: null,
            phoneCurrentState: state,
            stateTooltip: stateTooltip,
            sectionClass: sectionClass,
            stateClass: stateClass,
            seenDuration: null,
            seenDurationInterval: null,
            seenDurationColor: '',
            seenDurationProgressColor: '',
            moveFromStationDuration: null,
            moveFromStationDurationInterval: null,
            moveFromStationDurationColor: '',
            moveFromStationDurationProgressColor: '',
            arriveToLocationDuration: null,
            arriveToLocationDurationInterval: null,
            arriveToLocationDurationColor: '',
            arriveToLocationDurationProgressColor: '',
            patientVisitDuration: null,
            patientVisitDurationInterval: null,
            patientVisitDurationColor: '',
            patientVisitDurationProgressColor: '',
            arriveToHospitalDuration: null,
            arriveToHospitalDurationInterval: null,
            arriveToHospitalDurationColor: '',
            arriveToHospitalDurationProgressColor: '',
            hospitalWaitingDuration: null,
            hospitalWaitingDurationInterval: null,
            hospitalWaitingDurationColor: '',
            hospitalWaitingDurationProgressColor: '',
            missionId: temp[i].missionId ? temp[i].missionId : null,
            phoneId: temp[i].phoneId ? temp[i].phoneId : null,
          });
          if (temp[i].missionDuration) {
            let missionDuration = moment.duration(temp[i].missionDuration).asMinutes();
            let duration = Number(missionDuration) * 60;
            duration = duration * 1000;
            const index = this.dashboardData.length - 1;
            this.dashboardData[index].missionDurationInterval = setInterval(() => {
              duration = duration + 1000;
              this.dashboardData[index].missionDuration = this.msToTime(duration);
            }, 1000);
          }
          //seen Duration
          if (temp[i].seenDuration) {
            if (temp[i].seenDurationState == null) {
              let seenDuration = moment.duration(temp[i].seenDuration).asMinutes();
              let duration = Number(seenDuration) * 60;
              duration = duration * 1000;
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].seenDurationColor = '#F28810';
              this.dashboardData[index].seenDurationProgressColor = '#F28810';
              this.dashboardData[index].seenDurationInterval = setInterval(() => {
                duration = duration + 1000;
                this.dashboardData[index].seenDuration = this.msToTime(duration);
              }, 1000);
            } else if (temp[i].seenDurationState == false) {
              if (temp[i].seenTime) {
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].seenDurationColor = '#97462F';
                this.dashboardData[index].seenDurationProgressColor = '#97462F';
                this.dashboardData[index].seenDuration = Vue.moment(temp[i].seenTime).format(
                  'HH:mm',
                );
              } else {
                let seenDuration = moment.duration(temp[i].seenDuration).asMinutes();
                let duration = Number(seenDuration) * 60;
                duration = duration * 1000;
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].seenDurationColor = '#97462F';
                this.dashboardData[index].seenDurationProgressColor = '#97462F';
                this.dashboardData[index].seenDurationInterval = setInterval(() => {
                  duration = duration + 1000;
                  this.dashboardData[index].seenDuration = this.msToTime(duration);
                }, 1000);
              }
            } else {
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].seenDurationColor = '#0BA875';
              this.dashboardData[index].seenDurationProgressColor = '#0BA875';
              this.dashboardData[index].seenDuration = Vue.moment(temp[i].seenTime).format('HH:mm');
            }
          } else {
            const index = this.dashboardData.length - 1;
            this.dashboardData[index].seenDurationColor = '#907C79';
            this.dashboardData[index].seenDurationProgressColor = '#ffffff';
            this.dashboardData[index].seenDuration = '-';
          }
          //move From Station Duration
          if (temp[i].moveFromStationDuration) {
            if (temp[i].moveFromStationDurationState == null) {
              let moveFromStationDuration = moment
                .duration(temp[i].moveFromStationDuration)
                .asMinutes();
              let duration = Number(moveFromStationDuration) * 60;
              duration = duration * 1000;
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].moveFromStationDurationColor = '#F28810';
              this.dashboardData[index].moveFromStationDurationProgressColor = '#F28810';
              this.dashboardData[index].moveFromStationDurationInterval = setInterval(() => {
                duration = duration + 1000;
                this.dashboardData[index].moveFromStationDuration = this.msToTime(duration);
              }, 1000);
            } else if (temp[i].moveFromStationDurationState == false) {
              if (temp[i].moveFromStationTime) {
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].moveFromStationDurationColor = '#97462F';
                this.dashboardData[index].moveFromStationDurationProgressColor = '#97462F';
                this.dashboardData[index].moveFromStationDuration = Vue.moment(
                  temp[i].moveFromStationTime,
                ).format('HH:mm');
              } else {
                let moveFromStationDuration = moment
                  .duration(temp[i].moveFromStationDuration)
                  .asMinutes();
                let duration = Number(moveFromStationDuration) * 60;
                duration = duration * 1000;
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].moveFromStationDurationColor = '#97462F';
                this.dashboardData[index].moveFromStationDurationProgressColor = '#97462F';
                this.dashboardData[index].moveFromStationDurationInterval = setInterval(() => {
                  duration = duration + 1000;
                  this.dashboardData[index].moveFromStationDuration = this.msToTime(duration);
                }, 1000);
              }
            } else {
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].moveFromStationDurationColor = '#0BA875';
              this.dashboardData[index].moveFromStationDurationProgressColor = '#0BA875';
              this.dashboardData[index].moveFromStationDuration = Vue.moment(
                temp[i].moveFromStationTime,
              ).format('HH:mm');
            }
          } else {
            const index = this.dashboardData.length - 1;
            this.dashboardData[index].moveFromStationDurationColor = '#907C79';
            this.dashboardData[index].moveFromStationDurationProgressColor = '#ffffff';
            this.dashboardData[index].moveFromStationDuration = '-';
          }
          //arrive To Location Duration
          if (temp[i].arriveToLocationDuration) {
            if (temp[i].arriveToLocationDurationState == null) {
              let arriveToLocationDuration = moment
                .duration(temp[i].arriveToLocationDuration)
                .asMinutes();
              let duration = Number(arriveToLocationDuration) * 60;
              duration = duration * 1000;
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].arriveToLocationDurationColor = '#F28810';
              this.dashboardData[index].arriveToLocationDurationProgressColor = '#F28810';
              this.dashboardData[index].arriveToLocationDurationInterval = setInterval(() => {
                duration = duration + 1000;
                this.dashboardData[index].arriveToLocationDuration = this.msToTime(duration);
              }, 1000);
            } else if (temp[i].arriveToLocationDurationState == false) {
              if (temp[i].arriveToLocationTime) {
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].arriveToLocationDurationColor = '#97462F';
                this.dashboardData[index].arriveToLocationDurationProgressColor = '#97462F';
                this.dashboardData[index].arriveToLocationDuration = Vue.moment(
                  temp[i].arriveToLocationTime,
                ).format('HH:mm');
              } else {
                let arriveToLocationDuration = moment
                  .duration(temp[i].arriveToLocationDuration)
                  .asMinutes();
                let duration = Number(arriveToLocationDuration) * 60;
                duration = duration * 1000;
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].arriveToLocationDurationColor = '#97462F';
                this.dashboardData[index].arriveToLocationDurationProgressColor = '#97462F';
                this.dashboardData[index].arriveToLocationDurationInterval = setInterval(() => {
                  duration = duration + 1000;
                  this.dashboardData[index].arriveToLocationDuration = this.msToTime(duration);
                }, 1000);
              }
            } else {
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].arriveToLocationDurationColor = '#0BA875';
              this.dashboardData[index].arriveToLocationDurationProgressColor = '#0BA875';
              this.dashboardData[index].arriveToLocationDuration = Vue.moment(
                temp[i].arriveToLocationTime,
              ).format('HH:mm');
            }
          } else {
            const index = this.dashboardData.length - 1;
            this.dashboardData[index].arriveToLocationDurationColor = '#907C79';
            this.dashboardData[index].arriveToLocationDurationProgressColor = '#ffffff';
            this.dashboardData[index].arriveToLocationDuration = '-';
          }
          //patient Visit Duration
          if (temp[i].patientVisitDuration) {
            if (temp[i].patientVisitDurationState == null) {
              let patientVisitDuration = moment.duration(temp[i].patientVisitDuration).asMinutes();
              let duration = Number(patientVisitDuration) * 60;
              duration = duration * 1000;
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].patientVisitDurationColor = '#F28810';
              this.dashboardData[index].patientVisitDurationProgressColor = '#F28810';
              this.dashboardData[index].patientVisitDurationInterval = setInterval(() => {
                duration = duration + 1000;
                this.dashboardData[index].patientVisitDuration = this.msToTime(duration);
              }, 1000);
            } else if (temp[i].patientVisitDurationState == false) {
              if (temp[i].moveFromLocationTime) {
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].patientVisitDurationColor = '#97462F';
                this.dashboardData[index].patientVisitDurationProgressColor = '#97462F';
                this.dashboardData[index].patientVisitDuration = Vue.moment(
                  temp[i].moveFromLocationTime,
                ).format('HH:mm');
              } else {
                let patientVisitDuration = moment
                  .duration(temp[i].patientVisitDuration)
                  .asMinutes();
                let duration = Number(patientVisitDuration) * 60;
                duration = duration * 1000;
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].patientVisitDurationColor = '#97462F';
                this.dashboardData[index].patientVisitDurationProgressColor = '#97462F';
                this.dashboardData[index].patientVisitDurationInterval = setInterval(() => {
                  duration = duration + 1000;
                  this.dashboardData[index].patientVisitDuration = this.msToTime(duration);
                }, 1000);
              }
            } else {
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].patientVisitDurationColor = '#0BA875';
              this.dashboardData[index].patientVisitDurationProgressColor = '#0BA875';
              this.dashboardData[index].patientVisitDuration = Vue.moment(
                temp[i].moveFromLocationTime,
              ).format('HH:mm');
            }
          } else {
            const index = this.dashboardData.length - 1;
            this.dashboardData[index].patientVisitDurationColor = '#907C79';
            this.dashboardData[index].patientVisitDurationProgressColor = '#ffffff';
            this.dashboardData[index].patientVisitDuration = '-';
          }
          //arrive To Hospital Duration
          if (temp[i].arriveToHospitalDuration) {
            if (temp[i].arriveToHospitalDurationState == null) {
              let arriveToHospitalDuration = moment
                .duration(temp[i].arriveToHospitalDuration)
                .asMinutes();
              let duration = Number(arriveToHospitalDuration) * 60;
              duration = duration * 1000;
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].arriveToHospitalDurationColor = '#F28810';
              this.dashboardData[index].arriveToHospitalDurationProgressColor = '#F28810';
              this.dashboardData[index].arriveToHospitalDurationInterval = setInterval(() => {
                duration = duration + 1000;
                this.dashboardData[index].arriveToHospitalDuration = this.msToTime(duration);
              }, 1000);
            } else if (temp[i].arriveToHospitalDurationState == false) {
              if (temp[i].arriveToHospitalTime) {
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].arriveToHospitalDurationColor = '#97462F';
                this.dashboardData[index].arriveToHospitalDurationProgressColor = '#97462F';
                this.dashboardData[index].arriveToHospitalDuration = Vue.moment(
                  temp[i].arriveToHospitalTime,
                ).format('HH:mm');
              } else {
                let arriveToHospitalDuration = moment
                  .duration(temp[i].arriveToHospitalDuration)
                  .asMinutes();
                let duration = Number(arriveToHospitalDuration) * 60;
                duration = duration * 1000;
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].arriveToHospitalDurationColor = '#97462F';
                this.dashboardData[index].arriveToHospitalDurationProgressColor = '#97462F';
                this.dashboardData[index].arriveToHospitalDurationInterval = setInterval(() => {
                  duration = duration + 1000;
                  this.dashboardData[index].arriveToHospitalDuration = this.msToTime(duration);
                }, 1000);
              }
            } else {
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].arriveToHospitalDurationColor = '#0BA875';
              this.dashboardData[index].arriveToHospitalDurationProgressColor = '#0BA875';
              this.dashboardData[index].arriveToHospitalDuration = Vue.moment(
                temp[i].arriveToHospitalTime,
              ).format('HH:mm');
            }
          } else {
            const index = this.dashboardData.length - 1;
            this.dashboardData[index].arriveToHospitalDurationColor = '#907C79';
            this.dashboardData[index].arriveToHospitalDurationProgressColor = '#ffffff';
            this.dashboardData[index].arriveToHospitalDuration = '-';
          }
          //hospital Waiting Duration
          if (temp[i].hospitalWaitingDuration) {
            if (temp[i].hospitalWaitingDurationState == null) {
              let hospitalWaitingDuration = moment
                .duration(temp[i].hospitalWaitingDuration)
                .asMinutes();
              let duration = Number(hospitalWaitingDuration) * 60;
              duration = duration * 1000;
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].hospitalWaitingDurationColor = '#F28810';
              this.dashboardData[index].hospitalWaitingDurationProgressColor = '#F28810';
              this.dashboardData[index].hospitalWaitingDurationInterval = setInterval(() => {
                duration = duration + 1000;
                this.dashboardData[index].hospitalWaitingDuration = this.msToTime(duration);
              }, 1000);
            } else if (temp[i].hospitalWaitingDurationState == false) {
              if (temp[i].finishTime) {
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].hospitalWaitingDurationColor = '#97462F';
                this.dashboardData[index].hospitalWaitingDurationProgressColor = '#97462F';
                this.dashboardData[index].hospitalWaitingDuration = Vue.moment(
                  temp[i].finishTime,
                ).format('HH:mm');
              } else {
                let hospitalWaitingDuration = moment
                  .duration(temp[i].hospitalWaitingDuration)
                  .asMinutes();
                let duration = Number(hospitalWaitingDuration) * 60;
                duration = duration * 1000;
                const index = this.dashboardData.length - 1;
                this.dashboardData[index].hospitalWaitingDurationColor = '#97462F';
                this.dashboardData[index].hospitalWaitingDurationProgressColor = '#97462F';
                this.dashboardData[index].hospitalWaitingDurationInterval = setInterval(() => {
                  duration = duration + 1000;
                  this.dashboardData[index].hospitalWaitingDuration = this.msToTime(duration);
                }, 1000);
              }
            } else {
              const index = this.dashboardData.length - 1;
              this.dashboardData[index].hospitalWaitingDurationColor = '#0BA875';
              this.dashboardData[index].hospitalWaitingDurationProgressColor = '#0BA875';
              this.dashboardData[index].hospitalWaitingDuration = Vue.moment(
                temp[i].finishTime,
              ).format('HH:mm');
            }
          } else {
            const index = this.dashboardData.length - 1;
            this.dashboardData[index].hospitalWaitingDurationColor = '#907C79';
            this.dashboardData[index].hospitalWaitingDurationProgressColor = '#ffffff';
            this.dashboardData[index].hospitalWaitingDuration = '-';
          }
        }
      }
    },
    showConfirmDialogFor10_24: function (data) {
      this.missionPhoneId = data.id;
      this.sendModalType = '10-24-confirmation';
      this.$refs.confirm.title = '10-24 موقت';
      this.$refs.confirm.text = 'آیا از فعال سازی 10-24 اطمینان دارید؟';
      this.$refs.confirm.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      this.disabelConfirm = true;
      if (this.sendModalType === '10-24-confirmation') {
        this.missionPhoneTemp1024Function(this.missionPhoneId);
        this.showMenu = false;
      }
      this.resetConfirmDialog();
    },
    resetConfirmDialog: function () {
      this.$refs.confirm.title = '';
      this.$refs.confirm.text = '';
      this.$refs.confirm.showConfirmDialog = false;
    },
    confirmDialogCancelFunction: function () {
      this.disabelConfirm = true;
      this.resetConfirmDialog();
    },
    //times
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    showInformation: function (data) {
      this.missionId = data.missionId;
      this.missionPhoneId = data.id;
      this.phoneCode = data.code;
      this.phoneId = data.phoneId;
      this.followUpDashboardDetailModal = true;
    },
    closeDetailModal: function () {
      this.$root.$refs.FollowUpDashboardDetail.clearSetIntrvals();
      this.followUpDashboardDetailModal = false;
    },
    clearTimer: function () {
      clearTimeout(this.timer);
      this.timer = null;
    },
  },
  watch: {
    currentMissionSearchText: function (currentVal) {
      this.clearTimer();
      this.timer = setTimeout(() => {
        this.searchTxt = currentVal;
      }, 500);
    },
  },
};
